import { getComponentsByPrototype } from '../stores/componentManager';

export default class BookingCta extends HTMLElement {
    constructor(m) {
        super(m);

        /* Binding */
        this.onClick = this.onClick.bind(this);

        /* UI */
        this.$cta = this.querySelector('[data-booking-cta]');

        /* Data */
        this.panelTarget = this.getAttribute('data-panel-target');
        this.$targetTab = document.querySelector(`[data-booking-cta-target=${this.panelTarget}]`);
        this.locationSelectId = this.getAttribute('data-location-select-id');
        this.locationValue = this.getAttribute('data-location-value');
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    connectedCallback() {
        this.bindEvents();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.$cta.addEventListener('click', this.onClick);
    }

    unbindEvents() {
        this.$cta.removeEventListener('click', this.onClick);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onClick() {
        getComponentsByPrototype('Modal')
            .filter(($modal) => $modal.dataset.modalName === 'booking')
            .forEach(($modal) => {
                $modal.open();
            });

        const $tabs = getComponentsByPrototype('Tabs').find(
            ($modal) => $modal.dataset.tabsName === 'booking'
        );
        $tabs.setSelectedTab(this.$targetTab);

        if (this.locationSelectId && this.locationValue) {
            const $locationSelect = $tabs.querySelector(`#${this.locationSelectId}`);
            $locationSelect.value = this.locationValue;
            $locationSelect.dispatchEvent(new Event('change'));
        }
    }
}
